import axios from 'axios'
import { ENCRYPTING_ID } from '../../../config/realstar-api-config';


export const encryptingUserID = async (userEncryptedID) => {
    try {
        const url = `${ENCRYPTING_ID}${userEncryptedID}`; 

        const response = await axios.get(url);
        return response.data
    } catch (error) {
      console.error('Error decrypting id:', error);
      throw error;
    }
  }